import { Box } from '@yoweb/ui/components/Box';
import { ButtonIcon } from '@yoweb/ui/components/buttons/ButtonIcon';
import { CloseIcon } from '@yoweb/ui/components/Icon/CloseIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export var FlyoutClose = function FlyoutClose(_ref) {
  var onClose = _ref.onClose,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      bgColor = _ref.bgColor,
      iconSize = _ref.iconSize,
      dataTestId = _ref['data-testid'];
  return /*#__PURE__*/_jsx(Box, {
    position: "absolute",
    top: 0,
    right: 0,
    pt: {
      _: 'normal1',
      md: 'normal2'
    },
    pr: {
      _: 'normal1',
      md: 'normal2'
    },
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(ButtonIcon, {
      size: size,
      mode: "dark",
      variant: "primary",
      "data-testid": "flyout-close-button",
      type: "button",
      isFloating: false,
      icon: /*#__PURE__*/_jsx(CloseIcon, {
        fontSize: iconSize
      }),
      onClick: function onClick() {
        return onClose();
      },
      bgColor: bgColor
    })
  });
};